import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="analytics"
export default class extends Controller {
  static values = {
    containerId: String,
    testMode: Boolean,
  };

  connect() {
    window.dataLayer = window.dataLayer || [];

    if (localStorage.getItem('consentMode') === null) {
      this.gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_personalization: 'denied',
        ad_user_data: 'denied',
        analytics_storage: 'denied',
      });
    } else {
      this.gtag(
        'consent',
        'default',
        JSON.parse(localStorage.getItem('consentMode')),
      );
    }
  }

  gtag() {
    window.dataLayer.push(arguments);
  }

  setConsent(consent) {
    const consentMode = {
      ad_storage: consent.marketing ? 'granted' : 'denied',
      ad_personalization: consent.personalization ? 'granted' : 'denied',
      ad_user_data: consent.userData ? 'granted' : 'denied',
      analytics_storage: consent.analytics ? 'granted' : 'denied',
    };
    this.gtag('consent', 'update', consentMode);
    localStorage.setItem('consentMode', JSON.stringify(consentMode));
  }

  startTracking() {
    if (this.testModeValue) return;

    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    var scriptTag = document.createElement('script');
    scriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${this.containerIdValue}`;
    scriptTag.async = 1;
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);

    this.setConsent({
      marketing: false,
      personalization: false,
      userData: false,
      analytics: true,
    });
  }

  stopTracking() {
    if (this.testModeValue) return;

    this.setConsent({
      marketing: false,
      personalization: false,
      userData: false,
      analytics: false,
    });

    // Setting the consent mode stops the tracking but it doesn't delete the GA cookies. So we do it
    // manually.

    for (let cookie of document.cookie.split('; ')) {
      let name = cookie.split('=')[0];
      if (name.startsWith('_ga')) {
        // Google Analytics sets the domain of its cookies to '.vostel.de'. You can change the
        // domain (https://developers.google.com/tag-platform/security/guides/customize-cookies) but
        // Google will add a leading dot to any domain you set.
        //
        // According to MDN, leading dots should be ignored:
        // https://developer.mozilla.org/en-US/docs/Web/API/document/cookie
        // However, at least Firefox does not delete cookies with domain '.vostel.de' if we are on
        // vostel.de and don't specify the domain in the document.cookie invocation.
        document.cookie = `${name}=; expires=Mon Jan 01 1900 00:00:00; path=/; SameSite=Lax; domain=.vostel.de`;
      }
    }
  }
}
